export enum ReportType {
  SALESPERSON = 'search',
  INCOME = 'income',
  WORKSHEET = 'worksheet',
}
